import { render } from "./create_user.vue?vue&type=template&id=d676a1be"
import script from "./create_user.vue?vue&type=script&lang=js"
export * from "./create_user.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__